/**
 * Resolves the contact record (name/email/phone) most recently left on file
 * THIS conversation — shared by page.tsx (text chat's ToolTimeoutCard) and
 * the voice-call surface's CallToolTimeoutPanel (voice/call-tool-timeout-
 * panel.tsx), so "which contact record wins" can't drift between the two
 * surfaces. Extracted out of page.tsx's inline `knownContact` useMemo,
 * unchanged — a pure relocation, not a behavior change.
 *
 * Scans the WHOLE transcript (not scoped to a handoffId) because this flow
 * normally has no handoff of its own — see ToolTimeoutCard's
 * `nameOnFile`/`phoneOnFile` doc comments for the full "why". The most
 * recent record wins, same recency rule as every other "last matching row"
 * derivation in this app. Every ContactSummary carries a non-empty `name` by
 * construction (ContactSummaryEvent.name is required on the wire — see
 * aol_schemas.ws_events), so whenever the return value's `.phone` is set,
 * `.name` is guaranteed to be too.
 */
import { MessageRole, type ContactSummary, type Message } from '@/types/chat';

export function resolveKnownContact(
  messages: readonly Message[]
): ContactSummary | undefined {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i];
    if (m.role === MessageRole.SYSTEM && m.contactSummary) {
      return m.contactSummary;
    }
  }
  return undefined;
}
